import {Component} from "react";

let bgImageUrl="https://api.kehila.syn-assist.fr/bornes/bg-image/"
let borneUrl="https://tsedasmart-app.syn-assist.fr"

if(process.env.NODE_ENV !=='production'){
    bgImageUrl="https://kehilaapi.syn-assist.fr/bornes/bg-image/"
    borneUrl="http://localhost:3001"
}

export default class BorneOverlay extends Component {

    portrait=(localStorage.getItem("portrait") === "true")

    iframe=null

    state={
        show:false,
        bgImage:null,
        iframeKey:0
    }

    isShowed(){
        return this.state.show
    }

    async getBgImage()
    {
        const borneId=this.props.org["borne_id"] || null;
        if(!borneId){
            return null
        }

        const response= await fetch(bgImageUrl+borneId)
        if(response.ok){
            const data=await response.json()
            if(data.bgImage){
                this.setState({bgImage:data.bgImage})
            }
        }
    }


    showOverlay=()=>{
        if(this.state.show){
            return false
        }

        this.setState({show:true})
        this.iframe.contentWindow.postMessage({
            type: "SIMULATE_MOUSEMOVE"
        }, borneUrl);
    }

    hideOverlay(){
        this.setState({show:false})

        setTimeout(()=>{
            this.getBgImage()
            //this.setState({iframeKey:Date.now()})
        },3 * 1000)
    }

    componentDidMount()
    {
        if(this.props.getRef){
            this.props.getRef(this)
        }

        this.getBgImage()

        window.addEventListener("message", (event) => {
            //console.log("onMessage", event.origin,event.data)
            if (event.origin !== borneUrl) return;

            if (event.data === "IDLE_TIMEOUT") {
                console.log("IDLE_TIMEOUT");
                this.hideOverlay()
            }
        });
    }

    render()
    {
        const borneId=this.props.org["borne_id"] || null;
        //console.log(borneId,this.portrait);

        if(!this.portrait || !borneId ){
            return null
        }

        return(
            <div
                onClick={(e)=>{
                    e.preventDefault()
                    this.showOverlay()
                }}
                style={{
                    position:"absolute",
                    height:"100vh",
                    width:"100vw",
                    top:0,
                    bottom:0,
                    right:0,
                    left:0,
                    zIndex:100000,
                    background:this.state.show?"rgba(0, 0, 0, 1)":"linear-gradient(180deg,rgba(0, 0, 0,0) 80%, rgba(0, 0, 0, 0.7) 100%)",
                    backdropFilter: this.state.show ? "blur(50px)" : "none",
                    display:"flex",
                    alignItems:"center",
                    justifyContent:"center",
                    transitionDuration:this.state.show?"0.3s":"1s"
                }}
            >

                <img
                    src={this.state.bgImage?this.state.bgImage:"/images/borne_bg.png"}
                    style={{
                        opacity: this.state.show ? 1 : 0,
                        position: "absolute",
                        top: 0,
                        left: 0,
                        zIndex: 100001,
                        height: "100%",
                        width: "100%",
                        objectFit: "cover",
                        transitionDuration:this.state.show?"0.3s":"1s"
                    }}
                />


                <div
                    onClick={(e)=>{
                        e.preventDefault()
                        this.showOverlay()
                    }}
                    style={{
                        opacity: this.state.show ? 1 : 0,
                        position: "absolute",
                        zIndex: 100002,
                        width: "100vw",
                        height: "100vh",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        paddingTop:"10vh",
                        transitionDuration:!this.state.show?"0.3s":"1s",
                        backgroundColor:"rgba(0, 0, 0, 0.5)",
                    }}
                >
                    <iframe
                        ref={ref=>this.iframe=ref}
                        style={{
                            transform:"scale(2)",
                            height: 844,
                            width: 390,
                            pointerEvents: this.state.show?"all":"none",
                            backgroundColor:"transparent",
                        }}
                        src={borneUrl+"?cacheIframe="+this.state.iframeKey+"&borne="+borneId}
                    />
                </div>


                <div style={{
                    opacity: this.state.show ? 0 : 1,
                    position: "absolute",
                    bottom: 0,
                    height: "10vh",
                    width: "100vw",
                    color: "#FFF",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    textAlign: "center",
                    fontSize: "5.3vw",
                    gap:20
                }}>
                    <i className="fa-solid fa-hand-holding-heart"></i>
                    <span style={{textDecorationLine: "underline"}}>Toucher l'écran pour faire un don</span>
                </div>

            </div>
        )
    }
}

